import * as Sentry from "@sentry/capacitor";
import { config } from "./config";

/**
 * Initialize Sentry with the DSN URL. This will allow us to track errors and
 * performance issues in the application.
 *
 * @see https://sentry.apomap.dev/organizations/apomap/projects/apomap-mobile/?project=5
 */
export function initializeSentry() {
  Sentry.init({
    dsn: config.SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    environment: getSimplifiedEnvironment(),
    /**
     * If you're not already sampling the entire session, change the sample
     * rate to 100% when sampling sessions where errors occur.
     */
    replaysOnErrorSampleRate: 1.0,
  });
}

function getSimplifiedEnvironment() {
  const url = config.API_BASE_URL;

  if (url.includes(".dev")) {
    return "development";
  }

  if (url.includes(".staging")) {
    return "staging";
  }

  return "production";
}
